import { render, staticRenderFns } from "./RemoteFormItem.vue?vue&type=template&id=15d1fd11&"
import script from "./RemoteFormItem.vue?vue&type=script&lang=js&"
export * from "./RemoteFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports